module.exports = __webpack_public_path__ + "media/marketo-modal/hopin-plus-ba9acf16.png";